import { CycleProps } from 'core/domains/user';
import { formatCycle } from 'core/utilities/strings/format-cycle';
import { ToolTip } from 'ui/components/compounds';
import { Icon } from 'ui/components/primitives';
import { pluralize } from 'ui/utilities/helpers';

import Styles from './Cycle.styles';

export const Cycle = ({
  currentCycle,
  daysLeft,
  daysTotal,
  finalDate,
  initialDate,
  isMultiBrand,
  name,
}: CycleProps) => {
  const formatNumberDay = `${daysLeft}`.padStart(2, '0');
  const tooltipContent =
    'As datas representam o ciclo das marcas O Boticário, Eu Amo Make, O.U.i., e Australian Gold.';

  return (
    <>
      <Styles.ProgressWrapper data-is-multi-brand={isMultiBrand}>
        <Styles.CycleIcon size={16} data-hidden={true} />
        <Styles.Progress maxValue={daysTotal} reverse size="large" value={daysLeft} />
      </Styles.ProgressWrapper>
      <Styles.Info>
        <Styles.CycleDate>
          {isMultiBrand ? (
            <>
              <Styles.BrandName>{name}</Styles.BrandName>
              <Styles.CycleLength>
                Ciclo {formatCycle(currentCycle)}: {initialDate} a {finalDate}
              </Styles.CycleLength>
              {name === 'Boticário' && (
                <ToolTip align="center" content={tooltipContent} withIcon>
                  <Icon.Info size="s" />
                </ToolTip>
              )}
            </>
          ) : (
            <>
              Ciclo {formatCycle(currentCycle)}: {initialDate} a {finalDate}
            </>
          )}
        </Styles.CycleDate>
        <Styles.CycleDaysLeft>
          {pluralize(daysLeft, 'Falta', 'Faltam')}{' '}
          <span>
            {formatNumberDay} {pluralize(daysLeft, 'dia', 'dias')}
          </span>
          {''} para o ciclo acabar
        </Styles.CycleDaysLeft>
      </Styles.Info>
    </>
  );
};
